;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Collection 	= APP.module('Collection');
	var Model 		= APP.module('Model');

	Collection.TippingRoundStats =  Backbone.Collection.extend({
		url: function() {
			return this.methodUrl;
		},
		isNew: function(){
			return true;
		},
		getStats: function(round_id) {
			if (!_.isNumber(round_id)) {
				return this;
			}
			this.setApiUrl('round_stats/'+round_id+'.json');

			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));